/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Status_InjectedInputs */

const en_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const de_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const fr_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const es_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const it_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const nl_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const pl_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const fi_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const da_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

const sv_keyword_optimizer_status_injected = /** @type {(inputs: Keyword_Optimizer_Status_InjectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injected`)
};

/**
* | output |
* | --- |
* | "Injected" |
*
* @param {Keyword_Optimizer_Status_InjectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_status_injected = /** @type {((inputs?: Keyword_Optimizer_Status_InjectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Status_InjectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_status_injected(inputs)
	if (locale === "fr") return fr_keyword_optimizer_status_injected(inputs)
	if (locale === "es") return es_keyword_optimizer_status_injected(inputs)
	if (locale === "it") return it_keyword_optimizer_status_injected(inputs)
	if (locale === "nl") return nl_keyword_optimizer_status_injected(inputs)
	if (locale === "pl") return pl_keyword_optimizer_status_injected(inputs)
	if (locale === "fi") return fi_keyword_optimizer_status_injected(inputs)
	if (locale === "da") return da_keyword_optimizer_status_injected(inputs)
	if (locale === "sv") return sv_keyword_optimizer_status_injected(inputs)
	return en_keyword_optimizer_status_injected(inputs)
});